import { render, staticRenderFns } from "./TagesFormular.vue?vue&type=template&id=f8281a9c&"
import script from "./TagesFormular.vue?vue&type=script&lang=js&"
export * from "./TagesFormular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports